document.addEventListener('DOMContentLoaded', function () {
    const RESET_PASSWORD_SYNC_STORAGE_KEY = 'aa_pending_password_sync';
    const RESET_PASSWORD_SYNC_MAX_ATTEMPTS = 3;

    capturePendingPasswordReset();
    syncPendingPasswordReset();

    // ========== GOOGLE LOGIN ==========
    document.querySelector('.login-google-btn-open-popup')?.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const client = google.accounts.oauth2.initTokenClient({
            client_id: '464627350126-8csv0fvlqsng3lkst0hvuuhffbkkee15.apps.googleusercontent.com',
            scope: 'email profile',
            callback: function (tokenResponse) {
                if (tokenResponse.error) {
                    console.error('Google auth error:', tokenResponse.error);
                    document.querySelector('.error-banner.google-login')?.classList.remove('d-none');
                    return;
                }

                fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: { Authorization: 'Bearer ' + tokenResponse.access_token }
                })
                    .then(res => res.json())
                    .then(function (userInfo) {
                        fetch('https://app.ian.ng/api/google-email', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ email: userInfo.email })
                        })
                            .then(res => res.json())
                            .then(function (result) {
                                if (result.statusCode == 200 && result.status == 'success' && result.data && result.data.email) {
                                    document.getElementById('CustomerEmail').removeAttribute('name');
                                    document.getElementById('CustomerPassword').removeAttribute('name');

                                    const emailInput = document.createElement('input');
                                    emailInput.type = 'hidden';
                                    emailInput.name = 'customer[email]';
                                    emailInput.value = result.data.email;

                                    const passwordInput = document.createElement('input');
                                    passwordInput.type = 'hidden';
                                    passwordInput.name = 'customer[password]';
                                    passwordInput.value = result.data.password;

                                    const form = document.getElementById('customer_login');
                                    form.appendChild(emailInput);
                                    form.appendChild(passwordInput);
                                    form.submit();
                                } else {
                                    document.querySelector('.error-banner.google-login')?.classList.remove('d-none');
                                }
                            })
                            .catch(function (error) {
                                console.error('API error:', error);
                                document.querySelector('.error-banner.google-login')?.classList.remove('d-none');
                            });
                    })
                    .catch(function (error) {
                        console.error('Failed to fetch user info:', error);
                        document.querySelector('.error-banner.google-login')?.classList.remove('d-none');
                    });
            }
        });

        client.requestAccessToken({ prompt: 'select_account' });
    });

    // ========== GOOGLE REGISTER ==========
    document.querySelector('.register-google-btn-open-popup')?.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const client = google.accounts.oauth2.initTokenClient({
            client_id: '464627350126-8csv0fvlqsng3lkst0hvuuhffbkkee15.apps.googleusercontent.com',
            scope: 'email profile',
            callback: function (tokenResponse) {
                if (tokenResponse.error) {
                    console.error('Google auth error:', tokenResponse.error);
                    document.querySelector('.reg-mismatch-email')?.classList.remove('d-none');
                    return;
                }

                fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: { Authorization: 'Bearer ' + tokenResponse.access_token }
                })
                    .then(res => res.json())
                    .then(function (userInfo) {
                        const phoneNumber = getCookie('mobileNumber');

                        fetch('https://app.ian.ng/api/google-email', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ email: userInfo.email, mobile_no: phoneNumber })
                        })
                            .then(res => res.json())
                            .then(function (result) {
                                console.log(result);
                                if (result.statusCode == 200 && result.message == 'No data found') {
                                    document.querySelector('.password-google-login-hide')?.classList.add('d-none');
                                    document.querySelector('.register-google-btn-open-popup')?.classList.add('d-none');

                                    const firstNameInput = document.getElementById('RegisterForm-FirstName');
                                    const emailInput = document.getElementById('RegisterForm-email');

                                    if (firstNameInput) {
                                        firstNameInput.setAttribute('disabled', true);
                                        firstNameInput.value = userInfo.name;
                                    }
                                    if (emailInput) {
                                        emailInput.setAttribute('disabled', true);
                                        emailInput.value = userInfo.email;
                                    }

                                    if (result?.data?.mobile) {
                                        const datas = result.data;
                                        const genderData = (datas.gender == 'M') ? 'Male' : 'Female';

                                        const genderSelect = document.getElementById('RegisterForm-gender');
                                        if (genderSelect) genderSelect.value = genderData;

                                        const genderContainer = document.getElementById('select2-RegisterForm-gender-container');
                                        if (genderContainer) genderContainer.textContent = genderData;

                                        const dobInput = document.getElementById('RegisterForm-datepicker');
                                        if (dobInput) dobInput.value = datas.DOB;

                                        const raceSelect = document.getElementById('RegisterForm-race');
                                        if (raceSelect) raceSelect.value = datas.race;

                                        const raceContainer = document.getElementById('select2-RegisterForm-race-container');
                                        if (raceContainer && raceSelect?.value) raceContainer.textContent = datas.race;
                                    }
                                } else {
                                    document.querySelector('.reg-mismatch-email')?.classList.remove('d-none');
                                }
                            })
                            .catch(function (error) {
                                console.error('API error:', error);
                                document.querySelector('.reg-mismatch-email')?.classList.remove('d-none');
                            });
                    })
                    .catch(function (error) {
                        console.error('Failed to fetch user info:', error);
                        document.querySelector('.reg-mismatch-email')?.classList.remove('d-none');
                    });
            }
        });

        client.requestAccessToken({ prompt: 'select_account' });
    });

    // ========== STANDARD LOGIN INTERCEPT ==========
    // const customerLoginForm = document.getElementById('customer_login');
    // if (customerLoginForm) {
    //     customerLoginForm.addEventListener('submit', function (event) {
    //         // Found the email input
    //         const emailInput = document.getElementById('CustomerEmail');
    //         if (emailInput && emailInput.value && customerLoginForm.getAttribute('data-submitting') !== 'true') {
    //             event.preventDefault();
    //             event.stopImmediatePropagation();

    //             customerLoginForm.setAttribute('data-submitting', 'true');
    //             const submitBtn = customerLoginForm.querySelector('button[type="submit"]');
    //             const originalBtnText = submitBtn.innerHTML;
    //             submitBtn.innerHTML = '<span class="btn__text">Checking...</span>';

    //             fetch('https://app.ian.ng/api/google-email', {
    //                 method: 'POST',
    //                 headers: { 'Content-Type': 'application/json' },
    //                 body: JSON.stringify({ email: emailInput.value })
    //             })
    //                 .then(res => res.json())
    //                 .then(function (result) {
    //                     customerLoginForm.removeAttribute('data-submitting');
    //                     submitBtn.innerHTML = originalBtnText;

    //                     console.log(result);

    //                     if (result.statusCode == 200 && result.status == 'success' && result.data && result.data.email && result.data.password) {
    //                         // User is a google user. Prevent manual login and show error message.
    //                         const overrideErrorBox = document.querySelector('.google-login-override');
    //                         if (overrideErrorBox) {
    //                             overrideErrorBox.classList.remove('d-none');
    //                         }

    //                         // Hide default shopify login error if present
    //                         const defaultErrorBox = document.querySelector('.default-login-error');
    //                         if (defaultErrorBox) {
    //                             defaultErrorBox.classList.add('d-none');
    //                         }
    //                     } else {
    //                         // Non-google user. Submit the form correctly.
    //                         customerLoginForm.submit();
    //                     }
    //                 })
    //                 .catch(function (error) {
    //                     console.error('API error:', error);
    //                     customerLoginForm.removeAttribute('data-submitting');
    //                     submitBtn.innerHTML = originalBtnText;
    //                     customerLoginForm.submit();
    //                 });
    //         }
    //     });
    // }

    // ========== HELPER ==========
    function getCookie(cookieName) {
        const name = cookieName + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i].trim();
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return '';
    }

    function capturePendingPasswordReset() {
        const resetPasswordForm = document.querySelector('.reset-password form');
        if (!resetPasswordForm) return;

        resetPasswordForm.addEventListener('submit', function () {
            const passwordInput = resetPasswordForm.querySelector('#password');
            const passwordConfirmationInput = resetPasswordForm.querySelector('#password_confirmation');
            const password = passwordInput?.value?.trim();
            const passwordConfirmation = passwordConfirmationInput?.value?.trim();

            if (!password) return;
            if (passwordConfirmation && password !== passwordConfirmation) return;

            try {
                sessionStorage.setItem(RESET_PASSWORD_SYNC_STORAGE_KEY, JSON.stringify({
                    password: password,
                    attempts: 0,
                    createdAt: Date.now(),
                }));
            } catch (error) {
                console.warn('Unable to persist pending password sync:', error);
            }
        });
    }

    function syncPendingPasswordReset() {
        if (!window.__st?.cid) return;

        const pendingPasswordReset = getPendingPasswordReset();
        if (!pendingPasswordReset?.password) return;

        if ((pendingPasswordReset.attempts || 0) >= RESET_PASSWORD_SYNC_MAX_ATTEMPTS) {
            clearPendingPasswordReset();
            return;
        }

        setPendingPasswordReset({
            ...pendingPasswordReset,
            attempts: (pendingPasswordReset.attempts || 0) + 1,
        });

        fetch('https://app.ian.ng/api/update-details', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                customer_id: window.__st.cid,
                password: pendingPasswordReset.password,
            })
        })
            .then(function (response) {
                return response.json().catch(function () { return null; });
            })
            .then(function (result) {
                console.log('IAN sync password response:', result);
                if (result?.statusCode == 200 || result?.status == 'success') {
                    clearPendingPasswordReset();
                    return;
                }

                console.warn('IAN password sync did not succeed:', result);
            })
            .catch(function (error) {
                console.error('IAN password sync failed:', error);
            });
    }

    function getPendingPasswordReset() {
        try {
            const rawValue = sessionStorage.getItem(RESET_PASSWORD_SYNC_STORAGE_KEY);
            if (!rawValue) return null;

            const parsedValue = JSON.parse(rawValue);
            if (!parsedValue?.password) {
                clearPendingPasswordReset();
                return null;
            }

            return parsedValue;
        } catch (error) {
            clearPendingPasswordReset();
            return null;
        }
    }

    function setPendingPasswordReset(data) {
        try {
            sessionStorage.setItem(RESET_PASSWORD_SYNC_STORAGE_KEY, JSON.stringify(data));
        } catch (error) {
            console.warn('Unable to update pending password sync:', error);
        }
    }

    function clearPendingPasswordReset() {
        try {
            sessionStorage.removeItem(RESET_PASSWORD_SYNC_STORAGE_KEY);
        } catch (error) {
            console.warn('Unable to clear pending password sync:', error);
        }
    }

});


$(function () {
    $("#flag-with-code").intlTelInput({
        allowDropdown: true,
        nationalMode: true,
        onlyCountries: ["my"],
    });

    $("#RegisterForm-datepicker").datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: 'dd/mm/yy',
        yearRange: "1900:2050",
        showButtonPanel: true,
        closeText: "Cancel",
        currentText: "Done",
        beforeShowDay: function (date) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return date <= today ? [true] : [false];
        },
    });

    // Add focusing class to sibling .intl-tel-input when #mobile-number is focused
    $('#mobile-number').on('focus', function () {
        $(this).siblings('.intl-tel-input').addClass('focusing');
    }).on('blur', function () {
        $(this).siblings('.intl-tel-input').removeClass('focusing');
    });

    $('.js-example-basic-single').select2();
});
